module.exports = __webpack_public_path__ + "static/media/pvm-full.dc5f3252.png";